<template>
<div class="content">
    <div class="container-fluid">
    <div class="row">
        <div class="col-md-12">
        <absence-leave-management>
        </absence-leave-management> 
        </div>
    </div>  
    </div>
</div>
</template>
<script>
/* eslint-disable */
import absenceLeaveManagement from './todo-leave-management'
export default {
    components: {
        absenceLeaveManagement
    }
}
</script>
<style lang="scss">
</style>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/bp-leave-management/base-leave-management.vue